import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { USER_REQUEST } from "./types";

interface UserState {
  user: {
    currentUser: any | null;
    allUsers: any | null;
    userDetails: any | null;
    allClientRoles: any | null;
    certifications: any | null;
    blackOutDates: any;
  };
  loading: boolean;
  error: any | null;
}

const usersInitialState: UserState = {
  user: {
    currentUser: null,
    allUsers: null,
    userDetails: null,
    allClientRoles: null,
    certifications: null,
    blackOutDates: null,
  },
  loading: false,
  error: null,
};

export const userSlice = createSlice({
  name: USER_REQUEST,
  initialState: usersInitialState,
  reducers: {
    currentUserRequest(state) {
      state.loading = true;
      state.error = null;
    },
    currentUserSuccess(state, action: PayloadAction<{ response: any }>) {
      state.loading = false;
      state.user.currentUser = action.payload.response;
    },
    currentUserFailure(state, action: PayloadAction<{ error: any }>) {
      state.loading = false;
      state.error = action.payload.error;
    },
    getAllUserRequest(state, action: PayloadAction<any>) {
      state.loading = true;
      state.error = null;
    },
    getAllUserSuccess(state, action: PayloadAction<{ response: any }>) {
      state.loading = false;
      state.user.allUsers = action.payload.response;
    },
    getAllUserFailure(state, action: PayloadAction<{ error: any }>) {
      state.loading = false;
      state.error = action.payload.error;
    },
    getUserDetailsRequest(state, action: PayloadAction<any>) {
      state.loading = true;
      state.error = null;
    },
    getUserDetailsSuccess(state, action: PayloadAction<{ response: any }>) {
      state.loading = false;
      state.user.userDetails = action.payload.response;
    },
    getUserDetailsFailure(state, action: PayloadAction<{ error: any }>) {
      state.loading = false;
      state.error = action.payload.error;
    },
    getAllClientRolesRequest(state) {
      state.loading = true;
      state.error = null;
    },
    getAllClientRolesSuccess(state, action: PayloadAction<{ response: any }>) {
      state.loading = false;
      state.user.allClientRoles = action.payload.response;
    },
    getAllClientRolesFailure(state, action: PayloadAction<{ error: any }>) {
      state.loading = false;
      state.error = action.payload.error;
    },
    getUserCertificationsRequest(state, action: PayloadAction<any>) {
      state.loading = true;
      state.error = null;
    },
    getUserCertificationsSuccess(
      state,
      action: PayloadAction<{ response: any }>
    ) {
      state.loading = false;
      state.user.certifications = action.payload.response;
    },
    getUserCertificationsFailure(state, action: PayloadAction<{ error: any }>) {
      state.loading = false;
      state.error = action.payload.error;
    },
    getBlackOutDatesRequest(state, action) {
      state.loading = true;
      state.error = null;
    },
    getBlackOutDatesSuccess(state, action: PayloadAction<any>) {
      state.loading = false;
      state.user.blackOutDates = action.payload;
    },
    getBlackOutDatesFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  currentUserRequest,
  currentUserSuccess,
  currentUserFailure,
  getAllUserRequest,
  getAllUserSuccess,
  getAllUserFailure,
  getUserDetailsRequest,
  getUserDetailsSuccess,
  getUserDetailsFailure,
  getAllClientRolesRequest,
  getAllClientRolesSuccess,
  getAllClientRolesFailure,
  getUserCertificationsRequest,
  getUserCertificationsSuccess,
  getUserCertificationsFailure,
  getBlackOutDatesRequest,
  getBlackOutDatesSuccess,
  getBlackOutDatesFailure,
} = userSlice.actions;
export default userSlice.reducer;
